import React, { memo, useMemo, useState } from "react";
import ListTable from "../../common/ListTable";
import CustomFilter from "../Common/CustomFilter";

const OrganizationListTable = (props) => {
  const {
    total,
    loading,
    defaultCurrent,
    pageSize,
    current,
    onChange,
    showFilter,
    handleFilter,
  } = props;

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        handleFilter={handleFilter}
        tableData={props.dataSource}
        fetchTableData={null}
        filterName="organization"
      />
    ),
    [showFilter],
  );

  return (
    <>
      {props.filter && memoizedCustomFilter}
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          emptyText="No records to show yet."
          dataSource={props.dataSource}
          columns={props.tableColumns}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
        />
      </div>
    </>
  );
};
export default memo(OrganizationListTable);
